module.exports = __webpack_public_path__ + "videos/3d_en.5f1817d.mp4";